
    const module = document.querySelector('.hero-slider');
    const hook = module.querySelector('.hook');
    const slider = module.querySelector('.keen-slider');
    
    const numSlides = slider.querySelectorAll('.keen-slider__slide').length;

    if (numSlides > 1) {
      let timeout;
    
      function clearNextTimeout() {
        clearTimeout(timeout);
      }
    
      function nextTimeout(instance) {
        clearTimeout(timeout);
        
        timeout = setTimeout(() => {
          instance.next();
        }, 6000);
      }
    
      const carousel = new KeenSlider(
        slider,
        {
          loop: true,
          slides: {
            perView: 1,
            spacing: 0,
          },
    
          created(instance) {
            createDotsPagination(instance, module);    
            nextTimeout(instance);
          },
    
          slideChanged(instance) {
            updateDots(instance, module);
          },
    
          dragStarted: clearNextTimeout,
          animationEnded(instance) {
            nextTimeout(instance);
          },
          updated(instance) {
            nextTimeout(instance);
          },
        }
      );
    }
  

  function createDotsPagination(sliderInstance, module) {
    const slides = sliderInstance.track.details.slides.length;
    const navWrapper = document.createElement('div');
    const dotsWrapper = document.createElement('div');

    navWrapper.classList.add('pagination');
    dotsWrapper.classList.add('dots');
    
    for (let i = 0; i < slides; i++) {
      const dot = document.createElement('button');
      dot.classList.add('dot');
      dot.setAttribute('aria-label', `Go to slide ${i + 1}`);
      dot.addEventListener('click', () => {
        sliderInstance.moveToIdx(i);
      });
      dotsWrapper.appendChild(dot);
    }
  
    navWrapper.appendChild(dotsWrapper);
    hook.appendChild(navWrapper);
    updateDots(sliderInstance, module);
  } 
  
  function updateDots(sliderInstance, module) {
    const dots = module.querySelectorAll('.dot');
    const current = sliderInstance.track.details.rel;

    dots.forEach((dot, idx) => {
      dot.classList.toggle('dot--active', idx === current);
    });
  }